module.exports = __webpack_public_path__ + "static/media/Arrow_down_solid.79ddc3a2.svg";